/* unplugin-vue-components disabled */import { render } from "./logout.vue?vue&type=template&id=09a3765b&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"

import "./logout.vue?vue&type=style&index=0&id=09a3765b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a3765b"],['__file',"src/pages/logout/logout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09a3765b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09a3765b', __exports__)) {
    api.reload('09a3765b', __exports__)
  }
  
  module.hot.accept("./logout.vue?vue&type=template&id=09a3765b&scoped=true", () => {
    api.rerender('09a3765b', render)
  })

}


export default __exports__